<template>
    <div>
        <div style="color: #8A2E26; font-size: 18px;font-weight: bold;"> <router-link :to="linkUrl">{{ zh_en=='zh'?'查看更多':'see more' }} >></router-link></div>
        <div style="display: flex; align-items: center;">
            <div style="width: 16px;height: 16px;border-radius: 50%;border: 2px solid #8A2E26;margin-right: 12px;">
            </div>
            <div style="width: 310px;border: 2px solid #8A2E26;"></div>
        </div>
    </div>
</template>

<script>
// @ is an alias to /src
export default {
    props:{
        linkUrl:{
            default:'/'
        }
    },
    data() {
        return {
        }
    },
    methods: {

    }

}
</script>
<style scoped>
 a {
  color: #8A2E26;
  font-size: 20px;
  text-decoration: none;
}
</style>

